import { utilReducerConstant } from "../reducerConstant";

const initialState = {
  stateList: [],
  countryList: [],
  languageList: [],
  categoryList: [],
};

const utilReducer = (state = initialState, action) => {
  switch (action.type) {
    case utilReducerConstant.SET_COUNTRY_LIST:
      return {
        ...state,
        countryList: action.payload,
      };
    case utilReducerConstant.SET_STATE_LIST:
      return {
        ...state,
        stateList: action.payload,
      };
    case utilReducerConstant.SET_LANGUAGE_LIST:
      return {
        ...state,
        languageList: action.payload,
      };
    case utilReducerConstant.SET_CATEGORY_LIST:
      return {
        ...state,
        categoryList: action.payload,
      };
    default:
      return state;
  }
};

export default utilReducer;
